<template>
  <div v-if="dataRow && (dataRow.couponId || dataRow.Coupon)" class="row">
    <div class="col-12 mb-2">
      <h5>بيانات الكوبون والخصم</h5>
    </div>
    <div class="col-12 col-sm-6 mb-3">
      <label class="form-label">كود الكوبون:</label>
      <div>{{ dataRow.Coupon && dataRow.Coupon.code ? dataRow.Coupon.code : 'غير متوفر' }}</div>
    </div>
    <div class="col-12 col-sm-6 mb-3">
      <label class="form-label">حالة الكوبون:</label>
      <div>
        <span :class="dataRow.couponAccepted ? 'badge bg-success' : 'badge bg-warning text-dark'">
          {{ dataRow.couponAccepted ? 'مطبق' : 'لم يطبق' }}
        </span>
      </div>
    </div>
    <div v-if="dataRow.Coupon && dataRow.Coupon.title" class="col-12 col-sm-6 mb-3">
      <label class="form-label">وصف الكوبون:</label>
      <div>{{ dataRow.Coupon.title }}</div>
    </div>
    <div v-if="dataRow.couponType" class="col-12 col-sm-6 mb-3">
      <label class="form-label">نوع الخصم:</label>
      <div>{{ dataRow.couponType === 'percentage' ? 'نسبة مئوية' : 'قيمة ثابتة' }}</div>
    </div>
    <div v-if="dataRow.couponAmount != null" class="col-12 col-sm-6 mb-3">
      <label class="form-label">قيمة الخصم:</label>
      <div>{{ dataRow.couponAmount }} {{ dataRow.couponType === 'percentage' ? '٪' : 'ريال' }}</div>
    </div>
    <div v-if="dataRow.couponAccepted && dataRow.priceAfterDiscount != null" class="col-12 col-sm-6 mb-3">
      <label class="form-label">قيمة الطلب بعد الخصم:</label>
      <div class="text-success fw-bold">{{ dataRow.priceAfterDiscount }} ريال</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertyDocCouponDetails',
  props: {
    dataRow: {
      type: Object,
      default: null,
    },
  },
}
</script>
